import React from 'react';

const ErrorStatsvgIcon = ({ size = '152', className = '' }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 152 156" 
      className={className}
      style={{ flex: 'none' }}
    >
      <g fill="#FFCE00" fillRule="evenodd">
        <path d="M18.78 39.62a2 2 0 013.198 2.402 69.863 69.863 0 00-9.385 16.984 2 2 0 01-3.736-1.429 73.862 73.862 0 019.922-17.956zm-8.943 73.234a2 2 0 113.683-1.56 69.89 69.89 0 007.742 13.712 2 2 0 01-3.24 2.346 73.89 73.89 0 01-8.185-14.498zm128.226 14.38a2 2 0 11-3.245-2.339C143.342 113.075 148 98.891 148 84c0-14.736-4.562-28.782-12.922-40.533a2 2 0 113.26-2.319C147.174 53.571 152 68.426 152 84c0 15.737-4.927 30.738-13.937 43.235zM105.268 15.187a2 2 0 01-1.475 3.719C95.657 15.678 86.946 14 78 14c-6.724 0-13.32.948-19.647 2.794a2 2 0 11-1.121-3.84A74.026 74.026 0 0178 10c9.453 0 18.664 1.774 27.268 5.186z" opacity="0.7"></path>
        <path d="M12 7.96h5.46a2 2 0 110 4H12v5.461a2 2 0 11-4 0v-5.46H2.54a2 2 0 110-4H8V2.5a2 2 0 114 0v5.46z" opacity="0.3"></path>
        <path d="M126 97.96h5.46a2 2 0 010 4H126v5.461a2 2 0 11-4 0v-5.46h-5.46a2 2 0 110-4H122V92.5a2 2 0 014 0v5.46z" opacity="0.4"></path>
        <path d="M145.5 16.48h2.23a1.5 1.5 0 010 3h-2.23v2.23a1.5 1.5 0 01-3 0v-2.23h-2.23a1.5 1.5 0 010-3h2.23v-2.23a1.5 1.5 0 013 0v2.23z" opacity="0.2"></path>
        <g fill="rgba(255,255,255,0.4)">
          <path fillRule="nonzero" d="M41.95 59H124a4 4 0 004-4V28a4 4 0 00-4-4H42m.037-2H124a6 6 0 016 6v27a6 6 0 01-6 6H42.01"></path>
          <path d="M32 22h10v39H32a6 6 0 01-6-6V28a6 6 0 016-6zm16.5 5a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm8 1h34a1.5 1.5 0 010 3h-34a1.5 1.5 0 010-3zM48 35h59a1 1 0 010 2H48a1 1 0 010-2zm0 5h30a1 1 0 010 2H48a1 1 0 010-2zm1.5 10h5a2.5 2.5 0 110 5h-5a2.5 2.5 0 110-5z"></path>
        </g>
        <g fill="rgba(255,255,255,0.4)">
          <path fillRule="nonzero" d="M15.95 104H98a4 4 0 004-4V73a4 4 0 00-4-4H16m.037-2H98a6 6 0 016 6v27a6 6 0 01-6 6H16.01"></path>
          <path d="M6 67h10v39H6a6 6 0 01-6-6V73a6 6 0 016-6zm16.5 5a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm8 1h34a1.5 1.5 0 010 3h-34a1.5 1.5 0 010-3zM22 80h59a1 1 0 010 2H22a1 1 0 010-2zm0 5h30a1 1 0 010 2H22a1 1 0 010-2zm1.5 10h5a2.5 2.5 0 110 5h-5a2.5 2.5 0 110-5z"></path>
        </g>
        <g fill="rgba(255,255,255,0.4)">
          <path fillRule="nonzero" d="M41.95 153H124a4 4 0 004-4v-27a4 4 0 00-4-4H42m.037-2H124a6 6 0 016 6v27a6 6 0 01-6 6H42.01"></path>
          <path d="M32 116h10v39H32a6 6 0 01-6-6v-27a6 6 0 016-6zm16.5 5a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm8 1h34a1.5 1.5 0 010 3h-34a1.5 1.5 0 010-3zm-8.5 7h59a1 1 0 010 2H48a1 1 0 010-2zm0 5h30a1 1 0 010 2H48a1 1 0 010-2zm1.5 10h5a2.5 2.5 0 110 5h-5a2.5 2.5 0 110-5z"></path>
        </g>
      </g>
    </svg>
  );
};

export default ErrorStatsvgIcon;
